import { render } from "./KnowledgeCoursesView.vue?vue&type=template&id=66ba14bc&scoped=true"
import script from "./KnowledgeCoursesView.vue?vue&type=script&lang=js"
export * from "./KnowledgeCoursesView.vue?vue&type=script&lang=js"

import "./KnowledgeCoursesView.vue?vue&type=style&index=0&id=66ba14bc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ba14bc"]])

export default __exports__